import React from 'react';
import { HorizontalCenteredContainer, SpinnerContainer } from './loading-spinner.styled';
import Spinner from '@atlaskit/spinner';
export var LoadingSpinner = function LoadingSpinner() {
  return /*#__PURE__*/React.createElement(SpinnerContainer, {
    "data-testid": "search-dialog-loading-spinner"
  }, /*#__PURE__*/React.createElement(HorizontalCenteredContainer, null, /*#__PURE__*/React.createElement(Spinner, null)));
};